

//uat
const PAYMENT_SERVER_URL_V2 = "https://intent-aequ6sgbrq-uc.a.run.app/"


export default PAYMENT_SERVER_URL_V2;